module.exports = __webpack_public_path__ + "img/close-small-white.7f116bd7.svg";